// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"498":"reservations","543":"gallery","594":"about","884":"admin"}[chunkId] + "." + {"498":"17ec4b0f","543":"e9c5a16c","594":"716b9e69","884":"c2947614"}[chunkId] + ".js";
};